/**
 * Input Stateless Component
 */
import * as React from "react";
import { Translate } from "react-localize-redux";
import { CurrencyCredomaticEnum, CurrencyEnum } from "root/shared/CurrencyEnum";

export interface IPayButtonProps {
  isSubscription: boolean;
  isValid: boolean;
  totalAmount: number;
  disable: boolean;
  currency?: string;
  isPayout?: boolean;
  isPayin?: boolean;
}
// istanbul ignore next
const PayButton: React.StatelessComponent<IPayButtonProps> = (
  props: IPayButtonProps
): React.ReactElement<object> => {
  function getSymbol(currency: string | undefined): string {
    switch (currency) {
      case CurrencyEnum.PEN:
        return CurrencyEnum.PEN;
      case CurrencyEnum.UF:
        return CurrencyEnum.UF;
      case CurrencyEnum.COP:
        return CurrencyEnum.COP;
      case CurrencyEnum.BRL:
        return CurrencyEnum.BRL;
      case CurrencyEnum.CLP:
        return CurrencyEnum.CLP;
      case CurrencyEnum.MXN:
        return CurrencyEnum.MXN;
      case CurrencyEnum.PAB:
        return CurrencyEnum.PAB;
      case CurrencyCredomaticEnum.NIO:
        return CurrencyCredomaticEnum.NIO;
      case CurrencyCredomaticEnum.CRC:
        return CurrencyCredomaticEnum.CRC;
      case CurrencyCredomaticEnum.GTQ:
        return CurrencyCredomaticEnum.GTQ;
      case CurrencyCredomaticEnum.HNL:
        return CurrencyCredomaticEnum.HNL;
      case CurrencyEnum.USD:
      case undefined:
        return CurrencyEnum.USD;
      default:
        return CurrencyEnum.USD;
    }
  }

  function getButtonText(): string {
    if (props.isSubscription) return "subscriptionButton";
    if (Boolean(props.isPayout)) return "payoutButton";
    if (Boolean(props.isPayin)) return "payinButton";

    return "payButton";
  }

  function getTotalAmount(): string {
    return `${Number.parseFloat(
      Number(props.totalAmount).toFixed(2)
    )} ${getSymbol(props.currency)}`;
  }

  return (
    <div className="button">
      <button
        type="submit"
        className={`btn btn-payment ${
          !props.isValid || props.disable ? "disabled" : "enabled"
        }`}
        disabled={!props.isValid || props.disable}
      >
        <Translate id={getButtonText()} />{" "}
        {Boolean(props.isPayin) ? "" : getTotalAmount()}
      </button>

      {Boolean(props.isPayin) ? (
        <div className="d-flex justify-content-center mt-3 subtitle-mxn-text">
          <Translate
            id="payinTotalAmountMessage"
            data={{ totalAmount: getTotalAmount() }}
          />
        </div>
      ) : null}
    </div>
  );
};

export { PayButton };



// WEBPACK FOOTER //
// ./src/components/UI/PayButton/PayButtonComponent.tsx